module.exports = __webpack_public_path__ + "static/media/versace_above.14514e81.jpg";